<div (visibilityChange)="onVisibilityChanged($event)"
     [intersectionDebounce]="0"
     appIntersectionObserver
     [ngClass]="{
          'hs-min': compData?.container?.feature?.type === F_TYPES.SHORTSTAY,
          'es-min': compData?.container?.feature?.type === F_TYPES.EXTENDEDSTAY,
          'ssp-min': compData?.container?.feature?.type === F_TYPES.SHORTSTAY_PACKAGE,
          'mapView': enableMapView
        }"
     class="property-card-detail"
>
  @if (compData?.container?.selectedProduct) {
    <app-b2b-desktop-promotion1-strip [src]="compData?.container?.source"></app-b2b-desktop-promotion1-strip>
  }
  <div [ngClass]="{ 'sold-out-item': compData?.container?.isSoldOut,
             'premium-property' : compData?.container?.starRating > 3 || compData?.container?.filters?.isPremium}"
       class="property-card">
    <div class="room-card">
      <div class="image-container">
        @if (compData?.container?.longStripPromotion) {

          <app-b2b-desktop-promotion2-strip
            [promotion]="compData?.container?.longStripPromotion"
          ></app-b2b-desktop-promotion2-strip>
        }
        <div (click)="onCardClick(null)" class="overlay-card-content w-100 h-100">
          <div class="flex-container flex-column ion-justify-content-between w-100 h-100">
            <div class="flex-container ion-justify-content-between">
              <div class="left-top">
                <!-- New property tag -->
                @if ((compData?.container?.filters?.isNewProperty | withInDateRange: 30) && (compData?.container?.feature?.type === F_TYPES.EXTENDEDSTAY || compData?.container?.feature?.type === F_TYPES.SHORTSTAY)) {
                  <div class="new-property">
                    <!-- @if (!isServer && visibilityStatus === intersectionStatus.Visible; ) {
                       <img
                         [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/new-property.png?format=webp&quality=90'"
                         class="tag-img" alt="new-property" width="45" height="45" loading="lazy"
                       >
                     }-->
                    New
                  </div>
                }

                <!--@if (compData?.container?.isCouplePackage) {
                  <div class="val-bg">
                    <img
                      [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/couple-badge.png?format=webp&quality=80&width=179&height=179'"
                      alt="valentine-badge" loading="lazy"
                      width="179" height="179">
                  </div>
                }-->

                <div class="premium-wrap">
                  @if (compData?.container?.starRating > 3 || compData?.container?.filters?.isPremium) {
                    <div class="premium-property">
                      <div class="premium-badge">
                        <div class="badge-box">
                          @if (!isServer && visibilityStatus === intersectionStatus.Visible; ) {
                            <!-- <img
                               [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/premium.png?format=webp&quality=90'"
                               class="premium-img"
                               alt="premium"
                               loading="lazy"
                               width="120"
                               height="120"
                             />-->
                              <!--<img ngSrc="https://i.postimg.cc/xjZh39Sj/premium-big.png" class="premium-img"
                                   alt="premium" loading="lazy" width="100" height="100">-->
                            <p class="ribbon">
                              <span class="text">
                                <strong class="bold">Premium</strong>
                              </span>
                            </p>
                          }
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="property-card-img-wrap">
          <div class="property-card-img">
            <!--<div class="img-sec">
              <img
                (click)="onCardClick(null)"
                [ngSrc]="pImage$ | async"
                width="410"
                height="196"
                [alt]="compData?.container?.image?.alt"
                [priority]="compData?.index === 0"
                #pImage
                (error)="pImage.src = placeHolderImage + '?format=webp&quality=50&width=410&height=196'">
              @if (compData?.container?.allImages?.length > 0) {
                <div class="see-all" (click)="openImageGallery()">See
                  All {{ compData?.container?.allImages?.length }} Images
                </div>
              }
            </div>-->
            <div class="img-flx">
              <!--<div (click)="onCardClick(null)" class="img-s">
                <img
                  #pImage
                  (error)="pImage.src = placeHolderImage + '?format=webp&quality=50&width=244&height=150'"
                  [alt]="compData?.container?.image?.alt"
                  [ngSrc]="compData?.container?.image?.path + '?format=webp&quality=' + imgQuality + '&height=' + imgHeight"
                  [priority]="compData?.index === 0"
                  height="140"
                  width="244"
                >
              </div>-->

              @for (image of compData?.container?.promotionImages
                | slice: 0 : 5; track
                image; let last = $last; let index = $index; ) {
                @defer (on viewport) {
                  <div class="img-s" (click)="onCardClick(null)">
                    <img
                      [ngSrc]="image?.path + '?format=webp&quality=' + imgQuality  + '&height=' + imgHeight"
                      width="224"
                      height="150"
                      [alt]="image?.alt"
                      [priority]="false"
                      #pImage
                      (error)="pImage.src = placeHolderImage + '?format=webp&quality=50&width=244&height=150'"
                    >
                  </div>
                } @placeholder {
                  <div class="img-s bg-plh"></div>
                }
              }
              @if (compData?.container?.pc1?.propertyPromotion?.listPageImageOverlay; as listPageImageOverlay) {
                <div class="dynamic-bg"
                     [ngStyle]="{ 'background': 'linear-gradient(45deg, rgb(26, 87, 152), rgb(82, 181, 255))','color': 'white' }"
                >
                  {{ listPageImageOverlay }}
                </div>
              }
              @if (compData?.container?.promotionImages?.length > 0) {
                <!--<div class="see-all" (click)="openImageGallery()">See
                  All {{ compData?.container?.promotionImages?.length }} Images
                </div>-->
                <div class="see-all">
                  <div tapEffect class="see-all-btn" (click)="openImageGallery()">View All</div>
                </div>
              }
            </div>

            <div class="icon-wrap">
              @if (compData?.container?.showWishList) {
                <div class="heart-icon svgIcon flex-container ion-align-items-center ion-justify-content-center"
                     (click)="toggleFavorite()"
                     [class.fav-btn]="isFavorite" tapEffect>
                  <!--                      &#10084;-->
                  <!--                      <span></span>-->
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                       stroke="currentColor" class="size-6">
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"/>
                  </svg>
                </div>
              }
              <div class="share">
                @if (!isServer && visibilityStatus === intersectionStatus.Visible; ) {
                  <div (click)="share()"
                       class="svgIcon flex-container ion-align-items-center ion-justify-content-center" tapEffect>
                    <!--<img class="share-icon"
                         [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/share-icon.png?format=webp&quality=80&width=18&height=18'"
                               alt="share" width="16" height="16">-->
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                         stroke="currentColor" class="size-6">
                      <path stroke-linecap="round" stroke-linejoin="round"
                            d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"/>
                    </svg>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="property-details premium-border">
        <div class="property-inner-wrap">
          <div class="header-wrap">
            <div class="property-detail-inner-wrap">
              <div class="property-info-header">
                <div class="main-header">
                  <div>
                    <div class="str-cer-sec">
                      @if (compData?.container?.starRatingConfig?.filledStars?.length > 0) {
                        <div class="stars-section flex-container ion-align-items-center">
                          @for (star of compData?.container?.starRatingConfig?.filledStars; let index = $index; track index; ) {
                            &#9733;
                          }
                        </div>
                      }
                    </div>
                    <div (click)="onCardClick(null); fireGoogleEvent();" class="hd-flx">
                      <!--<a
                      href="{{ hostWebsite + compData?.container?.seoNavigationUrl }}"
                      class="property-title"
                      onclick="return false;"
                      >
                      <app-text-clamp-shell class="title"
                        [config]="{ data: (compData?.container?.displayName | titlecase), row:  2 }">
                      </app-text-clamp-shell>
                    </a>-->
                      @if (compData?.container?.seoNavigationUrl) {
                        <a
                          [ngClass]="{ 'clamp-nme': compData?.container?.feature?.type === F_TYPES.EXTENDEDSTAY || compData?.container?.feature?.type === F_TYPES.SHORTSTAY }"
                          class="property-title"
                          href="{{ hostWebsite + compData?.container?.seoNavigationUrl }}"
                          onclick="return false;"
                          target="_blank"
                        >
                          {{ compData?.container?.displayName | titlecase }}
                        </a>
                      } @else {
                        <a
                          [ngClass]="{ 'clamp-nme': compData?.container?.feature?.type === F_TYPES.EXTENDEDSTAY || compData?.container?.feature?.type === F_TYPES.SHORTSTAY }"
                          class="property-title"
                          href="javascript:void(0)"
                        >
                          {{ compData?.container?.displayName | titlecase }}
                        </a>
                      }

                    </div>
                  </div>
                  <div class="rt-ct-sec">
                    @if (compData?.container?.ratingAndReviewConfig?.rating > 0) {
                      <div
                        class="flex-container rating-container">
                        <div class="rating">
                            <span class="rating-point">
                              {{ compData?.container?.ratingAndReviewConfig?.rating | number : '1.1-1' }}
                            </span>
                        </div>
                        <div class="votes-count">
                          @if (compData?.container?.ratingAndReviewConfig?.votes > 0) {
                            <span>
                                ({{ compData?.container?.ratingAndReviewConfig?.votes + ' ' + compData?.container?.ratingAndReviewConfig?.sRatingLabel }}
                              )
                              </span>
                          }
                        </div>
                      </div>
                    }

                    @if (compData?.container?.isB2bCertified) {
                      <div class="certified-wrap"
                           [ngStyle]="{'background': 'linear-gradient(95.1deg, #010567 0%, #1A559B 100%)'}">
                        <div class="certified-b-img">
                          <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/bag2bag-certified.png'"
                               alt="bag2bag-certified" width="100" height="100" loading="lazy">
                        </div>
                        <span class="badge-text" [ngStyle]="{'color': '#ffffff'}">Certified</span>
                      </div>
                    }
                  </div>
                  <!--<div class="icon-wrap">
                    @if (compData?.container?.showWishList) {
                      <div
                        class="heart-icon"
                        (click)="toggleFavorite()"
                        [class.fav-btn]="isFavorite"
                      >
                        &lt;!&ndash;                      &#10084;&ndash;&gt;
                        &lt;!&ndash;                      <span></span>&ndash;&gt;

                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                             stroke="currentColor" class="size-6">
                          <path stroke-linecap="round" stroke-linejoin="round"
                                d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"/>
                        </svg>

                      </div>
                    }
                    <div class="share">
                      @if (!isServer && visibilityStatus === intersectionStatus.Visible; ) {
                        <span (click)="share()">
                          <img class="share-icon"
                               [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/share-icon.png?format=webp&quality=80&width=18&height=18'"
                               alt="share" width="16" height="16">
                        </span>
                      }
                    </div>
                  </div>-->

                </div>

              </div>
              <div (click)="onCardClick(null)" class="loc-info">
                @if (compData?.container?.description) {
                  <span class="description">
                      {{ compData?.container?.description }}
                    </span>
                }
                @if (compData?.container?.distanceFromLocation) {
                  <span class="just-km">
                      {{ compData?.container?.distanceFromLocation }}
                    </span>
                }
              </div>

              <div class="flex-container ion-justify-content-between badge-info">
                <div class="left-bottom">
                  @if (compData?.container?.badges?.length > 0) {
                    <div class="scrolling-wrapper-flexbox ">
                      @for (badge of compData?.container?.badges; track badge) {
                        @if (badge?.text | isNotEmpty) {
                          <div class="badge-box">
                            <div class="badge-detail">
                              <div class="badge-img">
                                      <span class="tick-icon">
                                        &#10003;
                                      </span>
                              </div>
                              <div class="title">{{ badge?.text | titlecase }}</div>
                            </div>
                          </div>
                        }
                      }
                    </div>
                  }
                </div>
              </div>

              @if (compData?.container?.vendorOfferings) {
                <div class="vdr-ofr-wrp">
                  @for (vendorOffering of compData?.container?.vendorOfferings; track vendorOffering) {
                    <div class="venOfr">
                      <div>
                        <svg width="14px" height="14px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
                             fill="none" stroke="#179b4c" stroke-linecap="round" stroke-linejoin="round"
                             stroke-width="1.5">
                          <polyline points="2.75 8.75,6.25 12.25,13.25 4.75"/>
                        </svg>
                      </div>
                      <div class="title">
                        {{ vendorOffering?.title }}
                      </div>
                    </div>
                  }
                </div>
              }
              <div (click)="onCardClick(null)" class="card-body">
                <div class="body-wrap">

                  <!-- Offer 1 start here -->
                  @if (compData?.container?.pc1?.propertyPromotion?.pc1; as pc1Text) {
                    <div class="pty-hls">
                      <div>
                        <div class="pty-hls-img">
                          <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/star-offer-icon.png'"
                               alt="stars"
                               width="64" height="64">
                        </div>
                      </div>
                      <div>
                        <div class="desc">
                          {{ pc1Text }}
                        </div>
                      </div>
                    </div>
                  }
                  <!-- Offer 1 ends here -->

                  <!-- Offer 2 start here -->
                  @if (compData?.container?.pc1?.propertyPromotion?.pc2; as pc2Text) {
                    <div class="pty-s-hls">
                      <div>
                        <div class="pty-s-hls-img">
                          <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/flash-offer-icon.png'"
                               alt="stars"
                               width="64" height="64">
                        </div>
                      </div>
                      <div>
                        <div class="desc">
                          {{ pc2Text }}
                        </div>
                      </div>
                    </div>
                  }
                  <!-- Offer 2 ends here -->

                  @if (compData?.container?.filters?.preBookFood) {
                    <div class="pre-book-wrap">
                      <ng-container>
                        <div class="pre-book">
                          <div class="food-img">
                            @if (!isServer && visibilityStatus === intersectionStatus.Visible; ) {
                              <img
                                [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/pre-book-food.png' + '?format=webp&quality=90'"
                                alt="food" width="16" height="16">
                            }
                          </div>
                          <div class="title">Pre book your food</div>
                        </div>
                      </ng-container>
                    </div>
                  }
                </div>
                @if (compData?.container?.priceDetail) {
                  <div class="discounted-price-section">
                    <ng-container *ngTemplateOutlet="discountedRateTemplate;"></ng-container>
                  </div>

                }
              </div>

              <div (click)="onCardClick(null)" class="ofr-flx">

                <div class="inv-promo">
                  @if (compData?.container?.promotionData?.inventoryPromotionCard?.title) {
                    <div class="mem-cd-ttl">
                      {{ compData?.container?.promotionData?.inventoryPromotionCard?.title }}
                    </div>
                  }
                </div>

                <div class="prt-ofr">
                  @if (!compData?.container?.disableBookNow) {
                    @if (compData?.container?.priceDetail?.combinedListPageDiscount > 0 || compData?.container?.promotionData?.redeemCreditPointCard?.isCreditPointApplicable) {
                      <div class="ofr-wrap">
                        <!-- <div class="bg-cir">Offers</div>-->
                        <div class="dis-cir">
                          @if (compData?.container?.priceDetail?.combinedListPageDiscount > 0) {
                            <div class="info">
                              {{ compData?.container?.newCartDescription?.presentationData?.combinedListPageDiscountInfo }}
                            </div>
                          }
                          @if (compData?.container?.promotionData?.redeemCreditPointCard?.isCreditPointApplicable) {
                            <div class="info">
                              @if (compData?.container?.priceDetail?.combinedListPageDiscount > 0 && compData?.container?.promotionData?.redeemCreditPointCard?.isCreditPointApplicable) {
                                +
                              }
                              {{ compData?.container?.promotionData?.redeemCreditPointCard?.title }}
                            </div>
                          }
                        </div>
                      </div>
                    }
                  }

                  @if (compData?.container?.promotionData?.creditPointRewardCard?.title) {
                    <div class="app-login-card">
                      @if (compData?.container?.promotionData?.creditPointRewardCard?.title) {
                        <div
                          class="register-wrap">
                          <div class="coin-img">
                            @if (!isServer && visibilityStatus === intersectionStatus.Visible; ) {
                              <img
                                [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/coin-rupee.png' + '?format=webp&quality=90'"
                                alt="coin" width="18" height="18">
                            }
                          </div>
                          <div class="title">{{ compData?.container?.promotionData?.creditPointRewardCard?.title }}
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="btn-ftr">
                <ng-container
                  *ngTemplateOutlet="buttonsTemplate"
                ></ng-container>
              </div>
            </div>
          </div>

          @if (compData?.container?.hourOptions?.length > 0) {
            <div class="scroll-hours">
              <p class="hours-title">All Available Hours</p>
              <div class="all-hrs">
                <app-b2b-drag-scroll [config]="swiperConfig"
                                     [dragToId]="compData?.container?.uid + '-hour-' + compData?.container?.selectedHour">
                  @for (hourOption of compData?.container?.hourOptions; track hourOption) {
                    <app-b2b-drag-scroll-item [config]="swiperConfig">
                      <div class="hour-options">
                        <div id="{{compData?.container?.uid}}-hour-{{ hourOption?.hour }}"
                             [ngClass]="{
                                      'selected-hour': hourOption?.selected,
                                      'deactivated-hour': !hourOption?.active
                                   }" class="hours-selection">
                          @if (hourOption?.active) {
                            <div class="hourly-details active">
                              <div class="hour">{{ hourOption?.display }}</div>
                              <div class="rate">₹ {{ hourOption?.rate }}</div>
                              @if (!hourOption?.selected) {
                                <div (click)="onSelectHour(hourOption)"
                                     class="select-btn">
                                  Select
                                </div>
                              }
                              @if (hourOption?.selected) {
                                <div class="selected" (click)="onSelectHour(hourOption)">
                                  Selected
                                </div>
                              }
                            </div>
                          }
                          @if (!hourOption?.active) {
                            <div class="not-active">
                              <div class="hour">{{ hourOption?.display }}</div>
                              <div class="rate">Not Available</div>
                            </div>
                          }
                        </div>
                      </div>
                    </app-b2b-drag-scroll-item>
                  }
                </app-b2b-drag-scroll>
              </div>
            </div>
          }

          @if (compData?.container?.pc1?.textList?.length > 0) {
            <div class="ofr-bnr">
              @for (offer of compData?.container?.pc1?.textList; track offer) {
                <div class="ofr-txt" [innerHTML]="offer | safe: 'html'">
                </div>
              }
            </div>
          }

          @if (compData?.container?.isWishlist) {
            <div class="wish-lst-btn">
              @for (featureType of compData?.container?.featureTypes; track featureType) {
                @if (featureType === FEATURE_TYPES.SHORTSTAY) {
                  <button class="srh-htl"
                          (click)="onFeatureClick(featureType)">
                    Book Shortstay Hotels
                  </button>
                }
                @if (featureType === FEATURE_TYPES.EXTENDEDSTAY) {
                  <button class="ovr-htl"
                          (click)="onFeatureClick(featureType)">
                    Book Overnight Hotels
                  </button>
                }
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>

</div>

@if (!compData?.container?.hideGoogleSchema
&& compData?.container?.hotelListSchema
&& compData?.container?.hotelListSchema?.url) {
  <div class="hidden">
    <div itemscope="" itemtype="http://schema.org/Hotel">
      <span itemprop="name">{{ compData?.container?.hotelListSchema?.name }}</span>
      @if (compData?.container?.ratingAndReviewConfig?.rating > 0) {
        <div
          itemprop="aggregateRating" itemscope="" itemtype="http://schema.org/AggregateRating">
          <meta itemprop="ratingValue" content="{{compData?.container?.ratingAndReviewConfig?.rating}}"/>
          <meta itemprop="worstRating" content="1"/>
          <meta itemprop="reviewCount" content="{{compData?.container?.ratingAndReviewConfig?.votes}}"/>
          <meta itemprop="bestRating" content="5"/>
        </div>
      }
      <div itemprop="address" itemscope="" itemtype="http://schema.org/PostalAddress">
        <span itemprop="addressLocality">{{ compData?.container?.hotelListSchema?.address?.addressLocality }}</span>
        <span itemprop="addressRegion">{{ compData?.container?.hotelListSchema?.address?.addressRegion }}</span>
        <span itemprop="addressCountry">{{ compData?.container?.hotelListSchema?.address?.addressCountry }}</span>
        <span itemprop="streetAddress">{{ compData?.container?.hotelListSchema?.address?.streetAddress }}</span>
        <span itemprop="postalCode">{{ compData?.container?.hotelListSchema?.address?.postalCode }}</span>
      </div>
      <meta itemprop="priceRange" content="{{  compData?.container?.hotelListSchema?.priceRange }}"/>
      <meta itemprop="telephone" content="{{ compData?.container?.hotelListSchema?.telephone }}"/>
      <meta itemprop="url" content="{{ compData?.container?.hotelListSchema?.url }}"/>
      <meta itemprop="email" content="{{ compData?.container?.hotelListSchema?.email }}"/>
      <meta itemprop="image" content="{{ compData?.container?.hotelListSchema?.image }}"/>
      <div itemprop="geo" itemscope="" itemtype="http://schema.org/GeoCoordinates">
        <meta itemprop="latitude" content="{{ compData?.container?.hotelListSchema?.geo?.latitude }}"/>
        <meta itemprop="longitude" content="{{ compData?.container?.hotelListSchema?.geo?.longitude }}"/>
      </div>
    </div>
  </div>
}

<ng-template #buttonsTemplate>
  <!--@if (compData?.container?.promotionData?.inventoryPromotionCard?.title) {
    <div class="mem-cd-ttl">
      {{ compData?.container?.promotionData?.inventoryPromotionCard?.title }}
    </div>
  }-->
  @if (compData?.container?.feature?.type === F_TYPES?.SHORTSTAY_PACKAGE) {
    <div class="button-item book-now-btn">
      <div class="buttons-container">
        @if (compData?.container?.isEnquiry || compData?.container?.notBookable) {
          <button class="bk-btn" (click)="enquriyNow()">Enquire Now</button>
        }
        @if (!compData?.container?.notBookable) {
          <button class="bk-btn" (click)="onCardClick(null)">Book Now</button>
        }
      </div>
    </div>
  }
</ng-template>
<ng-template #discountedRateTemplate>
  <div class="discount-rate-cls">
    @if (compData?.container?.pc1?.propertyPromotion?.offerPromotionText; as offerPromotionText) {
      <div class="vdr-ofr">
        <div class="ofr-txt">{{ offerPromotionText }}</div>
      </div>
    }

    @if (!compData?.container?.disableBookNow) {
      <div class="lft-prc">
        @if (compData?.container?.priceDetail?.rackRate > 0) {
          <div class="rk-rte">
            <span class="rk-rte-dis">₹{{ compData?.container?.priceDetail?.rackRate }}</span>
            @if (compData?.container?.priceDetail?.totalListPageDiscountPercentage > 0) {
              <span class="tot-dis-wrp">
                  {{ compData?.container?.newCartDescription?.presentationData?.listPageDiscountInfo }}
                </span>
            }
          </div>
        }
        @if (compData?.container?.priceDetail?.listPageOfferedRate > 0) {
          <div class="off-prc">
            @if (compData?.container?.newCartDescription?.priceInfo) {
              <span>{{ compData?.container?.newCartDescription?.priceInfo }}</span>
            }
            <span>₹{{ compData?.container?.priceDetail?.listPageOfferedRate }}</span>
          </div>
        }
        @if (compData?.container?.newCartDescription?.presentationData?.listRoomInfo) {
          <div class="rvw-sec">
              <span class="rm-info">
                {{ compData?.container?.newCartDescription?.presentationData?.listRoomInfo }}
              </span>
            @if (compData?.container?.newCartDescription?.presentationData?.nightInfo) {
              <span class="nit-info">
                  {{ compData?.container?.newCartDescription?.presentationData?.nightInfo }}
                </span>
            }
            @if (compData?.container?.newCartDescription?.presentationData?.hourInfo) {
              <span class="hr-info">
                  {{ compData?.container?.newCartDescription?.presentationData?.hourInfo }}
                </span>
            }
          </div>
        }
        @if (compData?.container?.newCartDescription?.taxInfo) {
          <div class="tax-info">
            ({{ compData?.container?.newCartDescription?.taxInfo }})
          </div>
        }
      </div>
    }
    @if (compData?.container?.disableBookNowMessage) {
      <div class="err-msg">
        {{ compData?.container?.disableBookNowMessage }}
      </div>
    }
  </div>

</ng-template>


